"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.X = void 0;
var take_1 = require("./take");
var in_chars_1 = require("./in-chars");
var try_all_1 = require("./try-all");
var then_all_1 = require("./then-all");
var json_1 = require("./json");
exports.X = {
    take: take_1.take,
    inChars: in_chars_1.inChars,
    tryAll: try_all_1.tryAll,
    thenAll: then_all_1.thenAll,
    json: json_1.json,
};
//# sourceMappingURL=x.js.map